export default __webpack_public_path__ + "static/media/winner.e4ff01de.webp";